import { apiFetch } from './client.js';

/** Cliente del almacenamiento por plan ("Mis archivos"). */

export interface StorageStatusResponse {
  plan: 'start' | 'pro' | 'teams' | 'vitruvio';
  /** 'user' = espacio personal (Start/Pro/Vitruvio) · 'tenant' = pool del equipo (Teams). */
  scope: 'user' | 'tenant';
  used_bytes: number;
  quota_bytes: number;
  members: number;
  breakdown: {
    project_files: number;
    quote_excels: number;
    custom_dbs: number;
    catalogs: number;
    exports: number;
  };
}

export type StorageFileType = 'project_file' | 'quote_excel' | 'custom_db' | 'catalog' | 'export';

export interface StorageFile {
  id: string;
  type: StorageFileType;
  name: string;
  sizeBytes: number;
  at: string | null;
  projectId?: string;
  projectName?: string;
  quoteId?: string;
  /** Solo type='export': opus_json | resumen_pdf. */
  kind?: 'opus_json' | 'resumen_pdf';
}

export function getStorageStatus(): Promise<StorageStatusResponse> {
  return apiFetch<StorageStatusResponse>('/api/v1/storage');
}

export async function listStorageFiles(): Promise<StorageFile[]> {
  const r = await apiFetch<{ files: StorageFile[] }>('/api/v1/storage/files');
  return r.files;
}

export async function deleteStorageExport(id: string): Promise<void> {
  await apiFetch(`/api/v1/storage/exports/${id}`, { method: 'DELETE' });
}

/** Borra SOLO el Excel generado de una cotización (la cotización queda). */
export async function deleteQuoteExcel(quoteId: string): Promise<void> {
  await apiFetch(`/api/v1/storage/quote-excels/${quoteId}`, { method: 'DELETE' });
}

/** URL de descarga de un export de la carpeta "Para OPUS". */
export function exportDownloadUrl(id: string): string {
  return `/api/v1/storage/exports/${id}/download`;
}

export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 B';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}
